import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
  useEffect
} from 'react'
import { STORAGE_KEYS, clearAuth } from '../config/storage'

export const AuthContext = createContext(null)

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() =>
    localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
  )
  const [role, setRole] = useState(() =>
    localStorage.getItem(STORAGE_KEYS.USER_ROLE)
  )

  const [username, setUsername] = useState(() =>
    localStorage.getItem(STORAGE_KEYS.USERNAME)
  )

  const login = useCallback(
    (newToken, userRole, userName, refreshToken, userId) => {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, newToken)
      localStorage.setItem(STORAGE_KEYS.USER_ROLE, userRole)
      localStorage.setItem(STORAGE_KEYS.USERNAME, userName)
      if (refreshToken) {
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken)
      } else {
        localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
      }
      if (userId !== undefined && userId !== null) {
        localStorage.setItem(STORAGE_KEYS.USER_ID, String(userId))
      }

      setToken(newToken)
      setRole(userRole)
      setUsername(userName)
    },
    []
  )

  useEffect(() => {
    const handleSessionRefresh = (event) => {
      const session = event.detail
      if (!session) return
      setToken(session.accessToken)
      setRole(session.role)
      setUsername(session.username)
    }

    window.addEventListener('authSessionRefreshed', handleSessionRefresh)
    return () =>
      window.removeEventListener('authSessionRefreshed', handleSessionRefresh)
  }, [])

  const logout = useCallback(() => {
    clearAuth()
    setToken(null)
    setRole(null)
    setUsername(null)
  }, [])

  const value = useMemo(
    () => ({
      token,
      role,
      username,
      isAuthenticated: !!token,
      login,
      logout
    }),
    [token, role, username, login, logout]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}
